import { useStore } from "./store";
/**
 * Custom hook to access and select the application store state.
 *
 * @template T - The type returned by the selector function, defaults to `IUseStoreAplication`.
 * @param selector - Optional function to select a specific part of the store state.
 * @returns The selected state or the full application store state.
 */
export const useStoreAplication = () => {
    const store = useStore();
    const state = {
        app: store.app,
        ipLocation: store.ipLocation,
        quicksearch: store.quicksearch,
        availability: store.availability,
        actions: {
            setActiveTag: store.setActiveTag,
            setRecommendedLocations: store.setRecommendedLocations,
            setQuickSearchData: store.setQuickSearchData,
            setIpLocation: store.setIpLocation,
        },
    };
    return state;
};
